<template>
  <div class="donation-swish__overlay">
    <div class="donation-swish">
      <div class="donation-swish__logo">
        <img src="../assets/swish-black.png" />
      </div>
      <div
        :class="{ 'donation-swish__success': success }"
        class="donation-swish__content"
      >
        <p>
          {{ message }}
        </p>
        <div v-if="success" class="donation-swish__check">
          <img src="../assets/check-swish.svg" />
        </div>
        <div v-else-if="isInProgress" class="donation-swish__loader" />
        <div v-else class="donation-swish__warning">
          <img src="../assets/alert-triangle.svg" />
        </div>
        <button @click="action">{{ buttonLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'swish',

  props: {
    labels: {
      type: Object,
      required: true,
    },
    amount: {
      type: Number,
      default: null,
    },
    phone: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'Donor',
    },
    leadId: {
      type: Number,
      default: null,
    },
    paymentId: {
      type: String,
      default: null,
    },
  },

  watch: {
    paymentId: function (value) {
      if (value) {
        this.start();
      }
    },
  },

  data() {
    return {
      state: 'progress',
      interval: null,
      success: false,
    };
  },

  computed: {
    buttonLabel() {
      return this.state === 'progress' ? this.labels.cancel : this.labels.back;
    },

    message() {
      return this.success
        ? this.labels.thankyou
        : this.isInProgress
        ? this.labels.openSwish
        : this.labels.error;
    },

    isInProgress() {
      return ['progress', 'Payment initiated'].indexOf(this.state) > -1;
    },
  },

  methods: {
    action() {
      clearInterval(this.interval);
      this.state = 'progress';
      this.$emit('close', this.success);
    },

    start() {
      let self = this;
      this.interval = setInterval(function () {
        self.poll();
      }, 1000);
      setTimeout(function () {
        clearInterval(self.interval);
      }, 1000 * 60 * 3);
      window.location = 'swish://';
    },

    poll() {
      const formData = new FormData();
      formData.append('id', this.leadId);
      formData.append('action', 'swish_poll');
      formData.append('nonce', this.$parent.wpNonce);
      axios
        .post(this.$parent.wpAjax, formData)
        .then((res) => {
          if (res.data && res.data.id && res.data.status) {
            this.state = res.data.status;
            if (res.data.success === true) {
              this.success = true;
              clearInterval(this.interval);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.donation-swish {
  text-align: center;
  z-index: 999999;
  width: 336px;
  height: 260px;
  background-color: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -168px;
  margin-top: -130px;
  &__logo {
    padding: 27px 0 14px 0;
  }
  &__content {
    p {
      margin: 0 auto;
      width: 200px;
      color: #000;
      font-weight: 600;
      line-height: 19px;
      font-size: 14px;
    }
    button {
      cursor: pointer;
      padding: 10px;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      background: #ffffff;
      opacity: 0.8;
      border: 0.5px solid #000000;
      box-sizing: border-box;
      border-radius: 4px;
      color: #000;
      &:hover {
        opacity: 1;
      }
    }
  }
  &__success {
    p {
      line-height: 25px;
      font-size: 18px;
    }
  }
  &__check {
    img {
      width: 72px;
      height: 72px;
    }
    margin: 15px auto 10px;
  }
  &__warning {
    img {
      width: 41px;
      height: 41px;
    }
    margin: 15px auto 10px;
  }
  &__loader {
    margin: 15px auto 10px;
    border: 6px solid #f3f3f3;
    border-radius: 50%;
    border-top: 6px solid #000;
    width: 31px;
    height: 31px;
    animation: spin 2s linear infinite;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
